var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    staticClass: "d-flex align-items-center justify-content-center"
  }, [_c('div', {
    staticClass: "spnod-admin__form--main d-flex align-items-center flex-column",
    attrs: {
      "id": "who-main"
    }
  }, [_c('h3', {
    staticClass: "h3 mb-1"
  }, [_vm._v("Select Your Role")]), _vm._v(" "), _c('span', {
    staticClass: "text-muted mb-3"
  }, [_vm._v("\n      " + _vm._s(_vm.isTablet ? 'Click' : 'Hover over') + " the ? to learn more\n    ")]), _vm._v(" "), _c('RoleForm')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6fc218e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Pages/AdminAuth/WhoAreYou.vue
// module id = el24
// module chunks = 2